module.exports = __webpack_public_path__ + "img/app.6413e030.png";